import * as resultApi from "@/api/results/index";
import store from "@/store";
import * as mt from "@/store/results/mutation-types";
import { AreaAndScoreHistogramFilter } from '@/api/results/types';

export async function getFarmAnalysisResult(
  farmAnalysisUuid: string,
  harvestSeason = "SUMMER",
  cropType = "SOY"
) {
  return (
    await resultApi.getFarmAnalysisResult(
      farmAnalysisUuid,
      harvestSeason,
      cropType
    )
  ).data;
}

export async function getFarmAnalysisResultList(
  farmAnalysisUuid: string,
  harvestSeason = "SUMMER"
) {
  return (await resultApi.getFarmAnalysisResultList(farmAnalysisUuid, harvestSeason)).data;
}

export async function downloadGeoJson(url: string) {
  return await resultApi.downloadGeoJson(url);
}

export async function getScoreHistogramDto(histogramFilter: AreaAndScoreHistogramFilter, onlyUserOwners: boolean) {
  store.dispatch(`results/${mt.FETCHING_SCORE_HISTOGRAM}`);

  try {
    const histogramDTO = (await resultApi.findScoreHistogramByCropTypeAnalysisYear(histogramFilter.analysisYear, histogramFilter.cropType, 
      onlyUserOwners, histogramFilter.harvestSeason)).data;
    store.dispatch(`results/${mt.FETCH_SCORE_HISTOGRAM_SUCCESS}`, histogramDTO);
  } catch (err) {
    if (err.response && err.response.status === 404) {
      store.dispatch(`results/${mt.FETCH_SCORE_HISTOGRAM_FAILED}`);
    }
  }
}

export async function getAreaHistogramDto(histogramFilter: AreaAndScoreHistogramFilter, onlyUserOwners: boolean) {
  store.dispatch(`results/${mt.FETCHING_AREA_HISTOGRAM}`);

  try {
    const histogramDTO = (await resultApi.findAreaHistogramByCropTypeAnalysisYear(histogramFilter.analysisYear, histogramFilter.cropType, 
      onlyUserOwners, histogramFilter.harvestSeason)).data;
    store.dispatch(`results/${mt.FETCH_AREA_HISTOGRAM_SUCCESS}`, histogramDTO);
  } catch (err) {
    if (err.response && err.response.status === 404) {
      store.dispatch(`results/${mt.FETCH_AREA_HISTOGRAM_FAILED}`);
    }
  }
}

export async function getHarvestResult(uuid: string, harvestSeason: string, cropType: string) {
  await store.dispatch(`results/${mt.FETCH_HARVEST_RESULT_REQUEST}`);

  try {
    const harvestResultDTO = (await resultApi.getHarvestResult(uuid, harvestSeason, cropType)).data;
    await store.dispatch(`results/${mt.FETCH_HARVEST_RESULT_SUCCESS}`, harvestResultDTO);
    return harvestResultDTO;
  } catch (err) {
    if (err.response && err.response.status === 404) {
      await store.dispatch(`results/${mt.FETCH_HARVEST_RESULT_FAILED}`);
      return [];
    } else {
      throw err;
    }
  }
}
